// extracted by mini-css-extract-plugin
export default {"LayoutWrapper":"Layout_LayoutWrapper__sW4FP","MainContent":"Layout_MainContent__Nw5FH"};